import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from "react-router-dom";
import './index.css'
import App from './App'
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
// import * as serviceWorker from './serviceWorker'


ReactDOM.render(
    <BrowserRouter>
      <App/>
  </BrowserRouter>, 
document.getElementById('root'))

// serviceWorker.register(`./service-worker.js`)